import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Icon,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react'
import { ArrowLeft } from '../../../utils/constants/icons'
import { usePluginVersions } from '../../../hooks/useSystem'

const PluginDrawer = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const { data: fileContent } = usePluginVersions(isOpen)

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerBody>
          <Box p="16px">
            <Flex justifyContent="space-between" alignItems="center" mb="16px">
              <Flex gap="12px" alignItems="center">
                <Button
                  variant="neutral"
                  leftIcon={
                    <Icon viewBox="0 0 16 16" w="16px" h="16px">
                      <ArrowLeft />
                    </Icon>
                  }
                  onClick={onClose}
                >
                  Back
                </Button>
                <Flex>
                  <Text textStyle="b-xs" color="neutral.200">
                    Anglerfish Plugin
                  </Text>
                </Flex>
              </Flex>
            </Flex>
            <Flex w="100%" h="68px" pos="relative" justifyContent="left">
              <Box pos="absolute" left="44px">
                <Box
                  bgImage="/logo/blue-md.svg"
                  w="100px"
                  h="40px"
                  bgPos="center"
                  bgSize="contain"
                  bgRepeat="no-repeat"
                />

                <Text textStyle="b-xs" color="neutral.400" ml="8px">
                  ANGLERFISH PLUGIN
                </Text>
              </Box>
              <Box
                pos="absolute"
                w="60px"
                h="60px"
                bgPos="center"
                bgSize="contain"
                bgRepeat="no-repeat"
                bgImage="/logo/anglerfish.svg"
              />
            </Flex>

            {fileContent &&
              fileContent.map((content: { changes: string[]; version: string; date: string }) => {
                return (
                  <>
                    <Flex alignItems="flex-end" mt="16px">
                      <Box
                        w="32px"
                        h="32px"
                        bgPos="center"
                        bgSize="contain"
                        bgRepeat="no-repeat"
                        bgImage="/logo/anglerfish.svg"
                      />
                      <Text textStyle="h4" color="neutral.500">
                        {content.version}
                      </Text>
                      <Text textStyle="b-xs" color="neutral.300" ml="12px">
                        {new Date(content.date).toLocaleDateString()}
                      </Text>
                    </Flex>

                    <UnorderedList mt="8px">
                      {content.changes.map((change: string) => {
                        return (
                          <ListItem textStyle="b-sm" color="neutral.500" ml="16px">
                            {change}
                          </ListItem>
                        )
                      })}
                    </UnorderedList>
                  </>
                )
              })}
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}

export default PluginDrawer
